import {checkIfAiPromoJoinable} from '../aiMatch/checkIfAiPromoJoinable';

/**
 * Можно ли открыть промо-модалку «Битвы с AI Claude Opus» прямо сейчас.
 *
 * Зовем, пока лобби дня есть и матч еще не начался (checkIfAiPromoJoinable):
 * на начавшийся матч приглашать игроком поздно. Приоритет — самый низкий в
 * меню, ниже даже новости о рейтинговых обличиях: модалка ждет, пока свободна
 * очередь всех остальных модалок меню (isMenuModalQueueBusy — в том числе
 * пока наградные сверяются с сервером), и не ложится поверх того, что открыто
 * самим игроком или App (вход для гостя, установка приложения, вступительная
 * колода) — те же условия, что у новости (checkIfRankSkinsNewsOpenable).
 *
 * @param {Object} params
 * @param {Object|null} params.aiPromo - результат normalizeAiPromo
 * @param {boolean} params.isDue - в этот игровой день промо еще не закрывали
 * @param {boolean} params.isOpen - уже открыта
 * @param {boolean} params.isSeen - уже закрыта в этот заход в меню
 * @param {boolean} params.isMuted - заглушена на этот заход (игрок ушел в
 *   асинхронный переход — поиск матча, вход в лобби)
 * @param {boolean} params.isMenuModalQueueBusy
 * @param {string|null} [params.loginRequiredReason]
 * @param {boolean} [params.isAppInstallPromoOpen]
 * @param {boolean} [params.isIntroSlidesVisible]
 * @returns {boolean}
 */
export const checkIfAiMatchPromoOpenable = ({
  aiPromo,
  isDue,
  isOpen,
  isSeen,
  isMuted,
  isMenuModalQueueBusy,
  loginRequiredReason,
  isAppInstallPromoOpen,
  isIntroSlidesVisible,
}) => checkIfAiPromoJoinable(aiPromo)
  && Boolean(isDue)
  && !isOpen
  && !isSeen
  && !isMuted
  && !isMenuModalQueueBusy
  && !loginRequiredReason
  && !isAppInstallPromoOpen
  && !isIntroSlidesVisible;
